// View icons https://fontawesome.com/icons?d=gallery&s=light
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faArrowCircleLeft, faArrowCircleRight, faInbox, faPlusCircle, faBars,
  faCloudUpload, faBoxUsd, faBullhorn, faChartPie, faCog, faExpandWide,
  faAngleDown, faAngleRight, faSearch, faSignIn, faSignOut, faQuestionCircle,
  faSpinnerThird, faEye, faEdit, faRandom, faEllipsisV, faCalendarAlt,
  faClock, faLifeRing, faBell, faUser, faPlus, faStar, faTimesCircle,
  faSync, faEyeSlash, faShieldAlt, faFlag, faTrashAlt, faCheckCircle,
  faCopy, faTags, faToolbox, faArrows, faListUl, faLongArrowRight,
  faSlidersV, faChessBoard, faAlignLeft, faAlignCenter, faAlignRight,
  faArrowToLeft, faArrowToRight, faToggleOn, faToggleOff, faTimes,
  faCodeMerge, faFrown, faExclamationTriangle, faCheck, faExpandAlt,
  faCommentAltDots, faInfoCircle, faCircle, faClone, faAd, faCode,
  faEnvelopeOpen, faTable, faFileExport, faFileAlt, faUserCog,
  faBoxOpen, faPen, faClipboard, faChevronLeft, faFolder, faFile,
  faFolderOpen, faSpinner, faArrowDown, faLink, faBorderAll, faPlay,
  faFileAudio, faFileVideo, faFileExcel, faFileWord, faFilePdf,
  faFileCsv, faFileCode, faDownload, faUsers, faMinusCircle,
  faExchange, faArrowLeft as arrowLeft, faAngleLeft, faRepeat,
  faTrafficLightGo, faTrafficLightStop, faEllipsisH, faBoxUp, faUndo as undoIcon,
  faRedo as redoIcon, faDoorClosed, faLongArrowDown, faExternalLinkAlt as externalLinkAltIcon,
  faLockOpen, faLock, faIndent as faRIndent,faGlobe, faFilter
} from '@fortawesome/pro-light-svg-icons';
import {
  faPhotoVideo, faBold, faItalic, faUnderline, faSuperscript, faSubscript,
  faTextHeight, faTint, faPaintBrush, faListOl, faCamera, faTag, faEraser,
  faAlignJustify, faParagraph, faArrowsAltV, faOutdent, faIndent,
  faQuoteLeft, faSmile, faDollarSign, faMinus, faUndo, faRedo, faMagic,
  faExpand, faPrint, faMousePointer, faQuestion, faFont, faEllipsisV as faREllipsisV,
  faAlignLeft as faRAlignLeft, faAlignCenter as faRAlignCenter, faStrikethrough,
  faAlignRight as faRAlignRight, faListUl as faRListUl, faLink as faRLink,
  faTable as faRTable, faFile as faRFile, faFilePdf as faRFilePdf,
  faCode as faRCode, faExchangeAlt, faCommentAlt, faTrash, faStar as faRStar,
  faInfo, faArrowsAlt, faArrowLeft, faSearch as faRSearch, faExternalLinkAlt,
  faEdit as faREdit, faUnlink, faUpload, faFilm, faHeading, faBars as faRBars,
  faSquare, faCog as faRCog, faFileAudio as faRFileAudio, faFileCode as faRFileCode,
  faCompress, faPhoneLaptop, faLightbulbOn
} from '@fortawesome/pro-regular-svg-icons';
import { faStar as faSolidStar } from '@fortawesome/pro-solid-svg-icons';

const WYSIWYG_ICONS = [
  faPhotoVideo, faBold, faItalic, faUnderline, faSuperscript, faSubscript,
  faFont, faTextHeight, faTint, faPaintBrush, faListOl, faCamera, faTag,
  faEraser, faAlignJustify, faParagraph, faArrowsAltV, faOutdent, faIndent,
  faQuoteLeft, faSmile, faDollarSign, faMinus, faUndo, faRedo, faMagic,
  faExpand, faCompress, faPrint, faMousePointer, faQuestion, faREllipsisV, faRAlignCenter,
  faRAlignLeft, faStrikethrough, faRAlignRight, faRListUl, faRLink, faRTable,
  faRFile, faRFilePdf, faRCode, faExchangeAlt, faCommentAlt, faTrash, faRStar,
  faInfo, faArrowsAlt, faArrowLeft, faRSearch, faExternalLinkAlt, faREdit,
  faUnlink, faUpload, faFilm, faHeading, faRBars, faSquare, faRCog, faRFileAudio,
  faRFileCode, faPhoneLaptop, faLightbulbOn
];

// Initialize a custom library of specific icons, to be loaded once.
// Allows us to reference the icon by a string name, rather than import
// individually into each component.
const icons = [
  faArrowCircleLeft, faArrowCircleRight, faInbox, faPlusCircle, faBars,
  faCloudUpload, faBoxUsd, faBullhorn, faChartPie, faCog, faExpandWide,
  faAngleDown, faAngleRight, faAngleLeft, faSearch, faSignIn, faSignOut,
  faSpinnerThird, faEye, faEdit, faRandom, faEllipsisV, faCalendarAlt,
  faClock, faLifeRing, faBell, faUser, faPlus, faStar, faSolidStar,
  faTimesCircle, faSync, faEyeSlash, faShieldAlt, faFlag, faTrashAlt,
  faCheckCircle, faCopy, faTags, faToolbox, faArrows, faListUl,
  faLongArrowRight, faSlidersV, faChessBoard, faAlignLeft, faAlignCenter,
  faAlignRight, faArrowToLeft, faArrowToRight, faToggleOn, faToggleOff,
  faTimes, faCodeMerge, faFrown, faExclamationTriangle, faCheck, faExpandAlt,
  faCommentAltDots, faInfoCircle, faCircle, faClone, faAd, faCode,
  faEnvelopeOpen, faTable, faFileExport, faFileAlt, faUserCog,
  faBoxOpen, faPen, faClipboard, faChevronLeft, faFolder, faFile,
  faFolderOpen, faSpinner, faArrowDown, faLink, faBorderAll, faPlay,
  faFileAudio, faFileVideo, faFileExcel, faFileWord, faFilePdf,
  faFileCsv, faFileCode, faDownload, faUsers, faMinusCircle, faRepeat,
  faExchange, arrowLeft, faQuestionCircle, faTrafficLightGo, faTrafficLightStop,
  faEllipsisH, faBoxUp, undoIcon, redoIcon, faDoorClosed , faLongArrowDown, externalLinkAltIcon,
  faLockOpen, faLock, faRIndent,faGlobe, faFilter, ...WYSIWYG_ICONS,
];

library.add(...icons);
